module.exports = __webpack_public_path__ + "static/img/tick.9c570d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/styles/mailkit/img/tick.png
// module id = 2NVp
// module chunks = 1